// Third-party libraries
import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Stack, Typography, Divider } from "@mui/material";
import { GemstoneSearchContext } from "../../utils/stateHandlers/contexts";
import Modal from "../diamonds/controls/Modal";
import GemstoneCollections from "./GemstoneCollections";
import { FilterRow } from "./filter/FilterRow";
import ImageVideoToggle from "./ImageVideoToggle";

export default function GemstoneFilter(props) {
  const { gemstoneState, dispatch } = useContext(GemstoneSearchContext);
  const {
    filters,
    searchQuery,
    resetFilters,
    openHelpText,
    helpTextLabel,
    helpText,
  } = gemstoneState;

  const [showContactModal, setShowContactModal] = useState(false);

  const sendTo = useLocation();

  const {
    updateCheckedBoxes,
    switchToFancyColors,
    updateNominalRange,
    valueForColor,
    updateRange,
    loggedIn,
    clearFilters,
    setLocalFcIntensity,
    setImageToggle,
    imageToggle,
    collection,
  } = props;
  useEffect(() => {
    setLocalFcIntensity(["None"]);
    setImageToggle(false);
    dispatch({
      type: "setShowFancyColorFilter",
      payload: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilters]);

  return (
    <Stack spacing={1} alignItems="center" sx={{ marginBottom: "2rem" }}>
      <GemstoneCollections
        collection={collection}
        clearFilters={clearFilters}
        valueForColor={valueForColor}
        dispatch={dispatch}
      />
      <Typography>
        Need help finding the perfect gemstone? &nbsp;
        <span
          className="contact-us pointer"
          onClick={() => setShowContactModal(true)}
        >
          Contact Us
        </span>
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            sm: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(2, 1fr)",
          },
          paddingTop: "2rem",
        }}
      >
        {filters &&
          filters.map((filter) => (
            <FilterRow
              key={filter.name}
              filter={filter}
              dispatch={dispatch}
              searchQuery={searchQuery}
              resetFilters={resetFilters}
              updateCheckedBoxes={updateCheckedBoxes}
              updateRange={updateRange}
              updateNominalRange={updateNominalRange}
              valueForColor={valueForColor}
              loggedIn={loggedIn}
              switchToFancyColors={switchToFancyColors}
              sendTo={sendTo}
            />
          ))}

        <ImageVideoToggle
          imageToggle={imageToggle}
          setImageToggle={setImageToggle}
          updateCheckedBoxes={updateCheckedBoxes}
        />
      </Box>
      <Divider flexItem />
      <Modal
        title={helpTextLabel}
        onClose={() =>
          dispatch({
            type: "setOpenHelpText",
            payload: {
              open: false,
              label: "",
              text: "",
            },
          })
        }
        show={openHelpText}
      >
        {helpText}
      </Modal>
      <Modal
        title="Contact Us"
        onClose={() => setShowContactModal(false)}
        show={showContactModal}
      />
    </Stack>
  );
}
